import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { OrganizationService } from '../services/organization.service';
import { AuthService } from '../services/auth.service';
import { map, catchError, of } from 'rxjs';

export const organizationGuard: CanActivateFn = () => {
  const organizationService = inject(OrganizationService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.getUser();
  if (!user?.localAccountId) {
    router.navigate(['/login']);
    return false;
  }

  return organizationService.checkUserOrganization(user.localAccountId).pipe(
    map((response) => {
      if (response?.data?.organizationId) {
        // User already has an organization - redirect to home
        console.log('User already has organization, redirecting to home');
        router.navigate(['/']);
        return false;
      }
      // User doesn't have organization - allow access to signup
      return true;
    }),
    catchError((error) => {
      console.error('Error checking organization status:', error);
      // On error, allow access (fail open)
      return of(true);
    }),
  );
};
